/**
 * Gaming Report View
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var Form = require('class/form.class');
    var PortletView = require('modules/portlet/portlet.view');
    var GamingReportModel = require('portlets/cashier/gaming-report/gaming-report.model');

    module.exports = PortletView.extend({

        accessRules: {
            allow: ['user']
        },

        events: {
            'submit form': 'changeReportYear',
            'click .fn-print-report': 'printReport',
            'click .fn-export-report': 'exportReport'
        },

        initialize: function(options) {
            this.options = options;
            this.model = new GamingReportModel();
            this.getData();
        },

        render: function() {
            this.$el.html(this.tmpl('gaming-report',
                _.extend(this.model.getSpanishUserIdentityData(), {
                    selectedYear: (new Date()).getUTCFullYear()
                }
            )));

            return this;
        },

        renderContent: function(data) {
            this.$('.fn-gaming-report-content').html(this.tmpl('gaming-report-content', data ? data : this.model.getEmptyData()));

            this.form = new Form(this.$('form'));
        },

        getData: function(year) {
            this.model.getStatistics(year).done(this.renderContent.bind(this));
        },

        changeReportYear: function(e) {
            e.preventDefault();

            var year = parseInt(this.form.data().period);

            this.$('.fn-top-content-year').html(year);

            if (this.model.get('year') !== year) {
                this.getData(year);
            }
        },

        printReport: function() {
            window.print();
        }
    });
});